import React from "react";
import { useParams } from "react-router-dom";
import Loader from "@components/Loader";
import { useCouponOrdersQuery } from "@queries/coupons";
import "@styles/opencart-admin.css";

export default function CouponOrdersPage() {
  const { couponId } = useParams();
  const [page, setPage] = React.useState(1);
  const pageSize = 50;

  const { data, isLoading, isFetching, isError, error } =
    useCouponOrdersQuery(couponId, page, pageSize);

  const rows = data?.data || [];
  const total = data?.meta?.total ?? rows.length;
  const pages = Math.max(1, Math.ceil(total / pageSize));

  function formatDate(dt) {
    if (!dt) return "";
    if (typeof dt === "string") return dt.substring(0, 10);
    try {
      return new Date(dt).toISOString().substring(0, 10);
    } catch {
      return "";
    }
  }

  return (
    <div className="oc-content">
      {(isLoading || isFetching) && <Loader />}

      <div className="oc-header">
        <h1>Coupon Orders</h1>
        <nav className="oc-bc">
          <span>Home</span>
          <span className="sep">›</span>
          <span>Coupons</span>
          <span className="sep">›</span>
          <span>Orders</span>
        </nav>
      </div>

      <div className="oc-card">
        <div className="oc-toolbar" style={{ marginBottom: 12 }}>
          <div>
            <strong>Orders using coupon #{couponId}</strong>
          </div>
          <div>
            Total orders: <strong>{total}</strong>
          </div>
        </div>

        {isError && (
          <div style={{ color: "#c00", marginBottom: 8 }}>
            Error: {error?.message || "Unknown error"}
          </div>
        )}

        <table className="oc-table">
          <thead>
            <tr>
              <th style={{ width: 100 }}>Order ID</th>
              <th style={{ width: 120 }}>Invoice No</th>
              <th>Customer Name</th>
              <th style={{ width: 160 }}>Email</th>
              <th style={{ width: 120 }}>Telephone</th>
              <th style={{ width: 120 }}>Total</th>
              <th style={{ width: 120 }}>Date Added</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={7} style={{ textAlign: "center", padding: 24 }}>
                  No orders for this coupon
                </td>
              </tr>
            )}
            {rows.map((row) => (
              <tr key={row.order_id}>
                <td>{row.order_id}</td>
                <td>{row.invoice_no}</td>
                <td>{row.name}</td>
                <td>{row.email}</td>
                <td>{row.telephone}</td>
                <td>{row.total != null && row.total !== "" ? Number(row.total).toFixed(2) : ""}</td>
                <td>{formatDate(row.date_added)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        className="oc-card"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 16
        }}
      >
        <div>
          Showing page <strong>{page}</strong> of <strong>{pages}</strong> (
          {total} total)
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button
            className="oc-btn ghost"
            disabled={page <= 1}
            onClick={() => setPage(1)}
          >
            « First
          </button>
          <button
            className="oc-btn ghost"
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
          >
            ‹ Prev
          </button>
          <button
            className="oc-btn ghost"
            disabled={page >= pages}
            onClick={() => setPage((p) => p + 1)}
          >
            Next ›
          </button>
          <button
            className="oc-btn ghost"
            disabled={page >= pages}
            onClick={() => setPage(pages)}
          >
            Last »
          </button>
        </div>
      </div>
    </div>
  );
}

